import React from 'react'
import Link from 'next/link'
import classNames from 'classnames'
import { CategoryNavigationTreeItem } from '@dustin-web/microsite-data/src/graphql/product/generated/graphql-types'

type Props = {
  navItem: CategoryNavigationTreeItem
  selectedCategoryPath: string
  buildPublicUrl: (navItem: CategoryNavigationTreeItem) => string
  onItemClick?: (selection: string) => void
}

const SearchNavigationItem = ({
  navItem,
  selectedCategoryPath,
  buildPublicUrl,
  onItemClick,
}: Props) => {
  const isSelected = navItem.categoryPathSlug === selectedCategoryPath

  return (
    <Link
      onClick={() => onItemClick && onItemClick(navItem.categoryEnglishDisplayName)}
      href={buildPublicUrl(navItem)}
      shallow
      className={classNames({
        'c-filter-categories__category--selected': isSelected,
        'c-filter-categories__category-link': true,
      })}>
      <span className="c-filter-categories__category-name">{navItem.categoryDisplayName}</span>
      <span className="u-color-mute">{navItem.hits}</span>
    </Link>
  )
}

export default SearchNavigationItem
